import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  query getArticle($slug: ID!) {
    article(slug: $slug, locale: "en") {
      id
      title
      created
      updated
      excerpt
      body
      topic
      coverURL
      canonicalURL
      videoURL
      expired
      metadata
      tags
      author {
        name
        photoURL
        slug
        bio
      }
      reviewedBy {
        name
        slug
        bio
      }
      company {
        id
        name
        uniqueSymbol
        exchangeCountryISO
        canonicalURL
        analysisMisc {
          analystCount
        }
        info {
          shortDescription
        }
        secondaryIndustry {
          name
          friendlyName
          slug
        }
        score {
          sentence
          value
          future
          past
          health
          dividend
        }
      }
      recommendedMarketArticles {
        title
        slug
        canonicalURL
        author {
          name
          photoURL
          slug
        }
      }
      recommendedHumanArticles {
        title
        slug
        canonicalURL
        author {
          name
          photoURL
          slug
        }
      }
    }
  }
`);

export const queryFn = ({ slug }) => {
  return gqlClient.request(QUERY, {
    slug: encodeURIComponent(slug.toString()),
  });
};
